export const translations = {
  en: {
    // Sidebar
    newChat: "New chat",
    searchChats: "Search chats",
    library: "Library",
    theme: "Theme",
    dark: "Dark",
    light: "Light",
    settings: "Settings",
    chats: "Chats",
    noSavedChats: "No saved chats yet",
    
    // Chat Panel
    greeting: "I'm Esper. Let's transform your photos and videos.",
    describeEdit: "Describe what you want to edit...",
    enhancePhoto: "Enhance photo",
    removeBackground: "Remove background",
    warmColorGrade: "Warm color grade",
    coolColorGrade: "Cool color grade",
    blackWhite: "Black & White",
    denoise: "Denoise",
    sharpenDetails: "Sharpen details",
    upscale4k: "Upscale to 4K",
    bokehEffect: "Bokeh effect",
    
    // Presets
    enhance: "ENHANCE",
    bw: "B&W",
    warm: "WARM",
    cool: "COOL",
    vivid: "VIVID",
    cinema: "CINEMA",
    vintage: "VINTAGE",
    
    // Settings
    voiceLanguage: "Voice Language",
    voiceLanguageDesc: "Language for voice transcription",
    
    // Common
    save: "Save",
    share: "Share",
    undo: "Undo",
    redo: "Redo",
    like: "Like",
    edit: "Edit",
    move: "Move",
    add: "Add",
    transform: "Transform"
  },
  
  es: {
    // Sidebar
    newChat: "Nuevo chat",
    searchChats: "Buscar chats",
    library: "Biblioteca",
    theme: "Tema",
    dark: "Oscuro",
    light: "Claro",
    settings: "Configuración",
    chats: "Chats",
    noSavedChats: "Aún no hay chats guardados",
    
    // Chat Panel
    greeting: "Soy Esper. Transformemos tus fotos y videos.",
    describeEdit: "Describe lo que quieres editar...",
    enhancePhoto: "Mejorar foto",
    removeBackground: "Quitar fondo",
    warmColorGrade: "Grado cálido",
    coolColorGrade: "Grado frío",
    blackWhite: "Blanco y negro",
    denoise: "Reducir ruido",
    sharpenDetails: "Aumentar nitidez",
    upscale4k: "Escalar a 4K",
    
    // Presets
    enhance: "MEJORAR",
    bw: "B&N",
    warm: "CÁLIDO",
    cool: "FRÍO",
    vivid: "VÍVIDO",
    cinema: "CINE",
    vintage: "VINTAGE",
    
    // Settings
    voiceLanguage: "Idioma de voz",
    voiceLanguageDesc: "Idioma para transcripción de voz",
    
    // Common
    save: "Guardar",
    share: "Compartir",
    undo: "Deshacer",
    redo: "Rehacer",
    like: "Me gusta",
    edit: "Editar",
    move: "Mover",
    add: "Agregar",
    transform: "Transformar"
  },
  
  ja: {
    // Sidebar
    newChat: "新しいチャット",
    searchChats: "チャットを検索",
    library: "ライブラリ",
    theme: "テーマ",
    dark: "ダーク",
    light: "ライト",
    settings: "設定",
    chats: "チャット",
    noSavedChats: "保存されたチャットはまだありません",
    
    // Chat Panel
    greeting: "私はエスパーです。写真と動画を変身させましょう。",
    describeEdit: "編集したい内容を説明してください...",
    enhancePhoto: "写真を強化",
    removeBackground: "背景を削除",
    warmColorGrade: "暖色グレード",
    coolColorGrade: "寒色グレード",
    blackWhite: "白黒",
    denoise: "ノイズ除去",
    sharpenDetails: "詳細をシャープ化",
    upscale4k: "4Kにアップスケール",
    
    // Presets
    enhance: "強化",
    bw: "白黒",
    warm: "暖色",
    cool: "寒色",
    vivid: "鮮やか",
    cinema: "シネマ",
    vintage: "ビンテージ",
    
    // Settings
    voiceLanguage: "音声言語",
    voiceLanguageDesc: "音声転写の言語",
    
    // Common
    save: "保存",
    share: "共有",
    undo: "元に戻す",
    redo: "やり直し",
    like: "いいね",
    edit: "編集",
    move: "移動",
    add: "追加",
    transform: "変形"
  }
};
